import react, { useRef } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import Team1 from '../../../assets/images/team1.webp';
import Team2 from '../../../assets/images/team2.webp';
import Team3 from '../../../assets/images/team3.webp';
import Image from "../../elements/Image";

const teamMembers = [
  {
    name: "James Anderson",
    role: "Chief Executive Officer",
    image: Team1,
    description: "Designs, develops, and audits secure blockchain smart contracts, ensuring efficiency, scalability, and compliance for decentralized applications."
  },
  {
    name: "Michael Thompson",
    role: "Head of Blockchain Development",
    image: Team2,
    description: "Designs, develops, and audits secure blockchain smart contracts, ensuring efficiency, scalability, and compliance for decentralized applications."
  },
  {
    name: "Emily Johnson",
    role: "Head of Product",
    image: Team3,
    description: "Designs, develops, and audits secure blockchain smart contracts, ensuring efficiency, scalability, and compliance for decentralized applications."
  },
  {
    name: "Olivia Bennett",
    role: "Lead Smart Contract Engineer",
    image: Team3,
    description: "Designs, develops, and audits secure blockchain smart contracts, ensuring efficiency, scalability, and compliance for decentralized applications."
  },
  {
    name: "Olivia Bennett",
    role: "Lead Smart Contract Engineer",
    image: Team3,
    description: "Designs, develops, and audits secure blockchain smart contracts, ensuring efficiency, scalability, and compliance for decentralized applications."
  },
];

export default function TeamSwiper() {
  const prevRef = useRef(null);
  const nextRef = useRef(null);
  return (
    <div className="w-full sm:max-w-xl md:max-w-2xl lg:max-w-4xl xls:max-w-6xl xl:max-w-7xl 2xl:max-w-8xl 3xl:max-w-9xl mx-auto px-4 pt-28">
      <div className="relative flex flex-col">
        <h4 className="text-xl font-semibold mb-2 text-primary uppercase text-center leading-5">OUR TEAM</h4>
        <h2 className="text-5xl font-semibold text-center text-white leading-normal mb-2 max-w-[680px] mx-auto">A diverse team driving digital innovation forward.</h2>
        <div className="team-section relative h-full">
          <Swiper
            modules={[Navigation, Pagination]}
            spaceBetween={20}
            slidesPerView={4}
            navigation={{
              prevEl: prevRef.current,
              nextEl: nextRef.current,
            }}
            onBeforeInit={(swiper) => {
              swiper.params.navigation.prevEl = prevRef.current;
              swiper.params.navigation.nextEl = nextRef.current;
            }}
            breakpoints={{
              640: { slidesPerView: 1 },
              768: { slidesPerView: 2 },
              1024: { slidesPerView: 3 },
              1280: { slidesPerView: 4 },
            }}
          >
            {teamMembers.map((member, index) => (
              <SwiperSlide key={index}>
                <div className="flip-card w-full h-[500px] mt-10">
                  <div className="flip-card-inner relative w-full h-full transition-transform duration-500 transform-style-preserve-3d hover:rotate-y-180">
                    <div className="flip-card-front absolute w-full h-full bg-gradient-to-t from-[#007139] to-[#0B1205] rounded-xl overflow-hidden">
                      <div className="relative z-10 w-full h-full pt-14 bg-gradient-to-t from-[#007139] to-[#0B1205]">
                        <Image src={member.image} fill classes="object-cover" />
                        <div className="absolute left-5 bottom-5 z-20">
                          <h3 className="text-xl text-white font-semibold leading-5 mb-2 uppercase">{member.name}</h3>
                          <p className="text-xs text-primary">{member.role}</p>
                        </div>
                        <div className="absolute inset-0 mt-auto bg-gradient-to-t from-[#00160D] to-[rgba(11,18,5,0)]  h-1/2"></div>
                      </div>
                    </div>
                    <div className="flip-card-back absolute top-0 left-0 w-full h-full bg-gradient-to-t from-[#007139] to-[#0B1205] rounded-xl px-5 pb-7 pt-12 flex flex-col justify-between">
                      <div>
                        <h3 className="text-xl text-white font-semibold leading-5 mb-2 uppercase">{member.name}</h3>
                        <p className="text-xs text-primary">{member.role}</p>
                      </div>
                      <p className="text-base text-white leading-normal">{member.description}</p>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            ))}

          </Swiper>
          <div
            ref={prevRef}
            className="absolute left-[-30px] top-1/2 -translate-y-1/2 z-50 cursor-pointer w-14 h-14 flex items-center justify-center rounded-full bg-black text-white border border-[#EEEEEE]"
          >
            <i className="fa-duotone !text-white  fa-regular fa-chevron-left"></i>

          </div>
          <div
            ref={nextRef}
            className="absolute right-[-30px] top-1/2 -translate-y-1/2 z-50 cursor-pointer w-14 h-14 flex items-center justify-center rounded-full bg-black !text-white border border-[#EEEEEE]"
          >
            <i className="fa-duotone fa-regular  !text-white fa-chevron-right"></i>
          </div> 
        </div>
      </div>
    </div>
  );
}
